import { render, staticRenderFns } from "./AppAvatanPermission.vue?vue&type=template&id=5a11a4fc&scoped=true&"
import script from "./AppAvatanPermission.vue?vue&type=script&lang=js&"
export * from "./AppAvatanPermission.vue?vue&type=script&lang=js&"
import style0 from "./AppAvatanPermission.vue?vue&type=style&index=0&id=5a11a4fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a11a4fc",
  null
  
)

export default component.exports